var modules_2054d19b = {"closeDialogButton":"MobileUserBlock_module_closeDialogButton__8c2b6452","dropdown":"MobileUserBlock_module_dropdown__8c2b6452","dropdownVisible":"MobileUserBlock_module_dropdownVisible__8c2b6452"};
import "../../../assets/esm/components/MobileUserBlock/src/MobileUserBlock~NhBy57ro.css";

export { modules_2054d19b as default };
//# sourceMappingURL=MobileUserBlock.module.less.js.map
